import { assessmentCohortModelModule } from './assessment-cohort';
import { assessmentInvitationModelModule } from './assessment-invitation';
import { assessmentModelModule } from './assessment';
import { assessmentResultModelModule } from './assessment-result';
import { assessmentResultReviewModelModule } from './assessment-result-review';
import { assessmentTemplateModelModule } from './assessment-template';
import { assessmentWorkflowPathModelModule } from './assessment-workflow-path';
import { candidateModelModule } from './candidate';
import { challengeItemModelModule } from './challenge-item';
import { challengeModelModule } from './challenge';
import { codeFileModelModule, codeFileSubclasses } from './code-file';
import { customerModelModule } from './customer';
import { externalRevisionModelModule } from './external-revision';
import { invoiceModelModule } from './invoice';
import { noteModelModule } from './note';
import { quizQuestionModelModule } from './quiz-question';
import { reviewQualityModelModule } from './review-quality';
import { solutionModelModule } from './solution';
import { solutionReviewModelModule } from './solution-review';
import { teamCandidateModelModule } from './team-candidate';
import { teamMemberModelModule } from './team-member';
import { teamModelModule } from './team';
import { userFeedbackModelModule } from './user-feedback-model';
import { webhookSubscriptionModelModule } from './webhook-subscriptions';

/**
 * Hacky way to ensure that all models are full-loaded at runtime
 */
const modelModules = [
  assessmentCohortModelModule,
  assessmentInvitationModelModule,
  assessmentModelModule,
  assessmentResultModelModule,
  assessmentResultReviewModelModule,
  assessmentTemplateModelModule,
  assessmentWorkflowPathModelModule,
  candidateModelModule,
  challengeItemModelModule,
  challengeModelModule,
  codeFileModelModule,
  customerModelModule,
  externalRevisionModelModule,
  invoiceModelModule,
  noteModelModule,
  quizQuestionModelModule,
  reviewQualityModelModule,
  solutionModelModule,
  solutionReviewModelModule,
  teamCandidateModelModule,
  teamMemberModelModule,
  teamModelModule,
  userFeedbackModelModule,
  webhookSubscriptionModelModule,
].map((mod) => mod.name);
const allModels = {};

// used to instantiate all the model factories
function runtimeFn(...modelClasses) {
  angular.forEach(runtimeFn.$inject, (m, i) => {
    if (modelClasses[i].name) {
      allModels[m] = modelClasses[i];
    }
  });
}

// set all the models as the injected objects
runtimeFn.$inject = modelModules
  .map(function (mod) {
    // converts name-with-hyphens to PascalCase (NameWithHyphens)
    const m = '-' + mod.match(/\.([^\.]+)$/)[1];
    return m.replace(/\-([a-z])/g, function (m, l) {
      return l.toUpperCase();
    });
  })
  .concat(codeFileSubclasses);

// Using `defineProperty` to make sure this method is not iterable.
Object.defineProperty(allModels, 'ejectAll', {
  get() {
    /**
     * Ejects all instances of all models from the in-memory cache.
     *
     * opts {{include:Array, exclude:Array}} Include or Exclude models from ejecting by name
     */
    return function (opts = { include: false, exclude: [] }) {
      angular.forEach(allModels, function (model, name) {
        if (opts.include) {
          if (opts.include.indexOf(name) !== -1) {
            model.ejectAll();
          }
        } else if (opts.exclude.indexOf(name) === -1) {
          model.ejectAll();
        }
      });
    };
  },
});

// create the module and initialize all factories on startup
export const allModelsModule = angular
  .module('Q.models.all-models', modelModules)
  .run(runtimeFn)
  .factory('allModels', () => allModels);
